import { useEffect, useState } from "react";
import { Switch } from "@headlessui/react";

interface ToggleProps {
  action: (status: boolean) => void;
  value?: boolean;
  isDisable?: boolean
}

const Toggle: React.FC<ToggleProps> = ({ action, value, isDisable = false }) => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (value !== undefined) {
      setEnabled(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handelChangeStatus = (value: boolean) => {
    if(value === undefined ) setEnabled(value);
    action(value);
  };

  return (
    <div className="left-to-right">
      <Switch
        disabled={isDisable}
        checked={value !== undefined ? value : enabled}
        onChange={handelChangeStatus}
        className={`${enabled ? "bg-[#008AF6]" : "bg-[#DDDDDD]"} relative inline-flex h-[24px] w-[44px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
      >
        <span
          aria-hidden="true"
          className={`${enabled ? "translate-x-5" : "translate-x-0"}
            pointer-events-none inline-block h-[20px] w-[20px] transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
        />
      </Switch>
    </div>
  );
};

export default Toggle;
